import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  ViewEncapsulation,
  ViewChild,
  ElementRef
} from '@angular/core';
import { Alert } from '../reservation-settings.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import 'rxjs/add/operator/takeUntil';
import { Observable, Subject } from 'rxjs';
import { ReservationService } from '@app/reservation/reservation.service';
import moment from 'moment';
moment.locale('de');
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { resStatus } from '@app/core/constants';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-add-time-filter',
  templateUrl: './add-time-filter.component.html',
  styleUrls: ['./add-time-filter.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AddTimeFilterComponent implements OnInit, OnDestroy {
  @Input() public editTimeFilterData: any; // only if editing
  @Input() public shiftData: any = [];
  @Input() public roomData: any = [];
  @Input() public tagData: any = [];
  @Input() public allStatusData: any = [];
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  resTimeFilterFormGroup: FormGroup;
  private ngUnsubscribe: Subject<any> = new Subject();
  time1: NgbTimeStruct;
  time2: NgbTimeStruct;
  allStatus: any[] = resStatus;
  tablesData: any = [];
  rooms: any = [];
  shifts: any = [];
  allTags: any = [];

  constructor(
    public activeModal: NgbActiveModal,
    public formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private reservationService: ReservationService
  ) {}

  ngOnInit() {
    this.loadFilter();
    this.resTimeFilterFormGroup = this.formBuilder.group({
      name: ['', Validators.required],
      from: ['', Validators.required],
      to: ['', Validators.required],
      roomIds: [null],
      shiftId: [null],
      tagIds: [null],
      status: [null]
    });
  }

  async loadFilter() {
    this.allStatus = this.allStatusData || resStatus;

    const tagPromise = this.tagData && this.tagData.length ? Promise.resolve(this.tagData) : this.getAllTags();
    const shiftPromise = this.shiftData && this.shiftData.length ? Promise.resolve(this.shiftData) : this.getShifts();
    const roomPromise = this.roomData && this.roomData.length ? Promise.resolve(this.roomData) : this.getRooms();

    const [tags, shifts, rooms] = await Promise.all([tagPromise, shiftPromise, roomPromise]);

    this.allTags = tags;
    this.shifts = shifts;
    this.rooms = rooms;
    if (this.editTimeFilterData) {
      let timeFrom = this.editTimeFilterData.from.split(':');
      this.time1 = {
        hour: parseInt(timeFrom[0]),
        minute: parseInt(timeFrom[1]),
        second: 0
      };
      let timeTo = this.editTimeFilterData.to.split(':');
      this.time2 = {
        hour: parseInt(timeTo[0]),
        minute: parseInt(timeTo[1]),
        second: 0
      };
      this.resTimeFilterFormGroup.addControl('id', new FormControl(this.editTimeFilterData.id, Validators.required));
      this.resTimeFilterFormGroup.get('from').setValue(this.time1);
      this.resTimeFilterFormGroup.get('to').setValue(this.time2);
      this.resTimeFilterFormGroup.get('name').setValue(this.editTimeFilterData.name);
      this.resTimeFilterFormGroup.get('status').setValue(this.editTimeFilterData.status || null);
      this.resTimeFilterFormGroup.get('tagIds').setValue(this.editTimeFilterData.tagIds || null);
      this.resTimeFilterFormGroup.get('roomIds').setValue(this.editTimeFilterData.roomIds || null);
      this.resTimeFilterFormGroup.get('shiftId').setValue(this.editTimeFilterData.shiftId || null);
    }
  }

  async getRooms(): Promise<any[]> {
    const data = await this.reservationService.getRooms(false).toPromise();

    if (!data) {
      return [];
    }

    const rooms = [...data];

    const allTables: any[] = [];
    rooms.forEach((room: any) => {
      allTables.push(...room.tables);
    });

    const allRooms = { ...rooms[0], id: 1000, name: 'All', tables: allTables };

    rooms.push(allRooms);

    // Assign state (optional)
    this.rooms = rooms;
    this.tablesData = rooms.length ? rooms[0].tables : [];

    return rooms;
  }

  async getShifts(): Promise<any[]> {
    const shifts = await this.reservationService
      .getShifts()
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise();

    this.shifts = shifts;

    if (this.editTimeFilterData) {
      this.resTimeFilterFormGroup.get('shiftId').setValue(this.editTimeFilterData.shiftId || null);
    }

    return shifts;
  }

  async getAllTags(): Promise<any[]> {
    const tags = await this.reservationService
      .getTags()
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise();

    this.allTags = tags;
    return tags;
  }

  add() {
    if (!this.resTimeFilterFormGroup.valid) {
      this.snackBar.open('Bitte überprüfen Sie Ihre Angaben.', '', {
        duration: 2000,
        panelClass: ['snackbar-error']
      });
      return;
    }
    this.resTimeFilterFormGroup.value.from = `${String(this.resTimeFilterFormGroup.value.from.hour).padStart(
      2,
      '0'
    )}:${String(this.resTimeFilterFormGroup.value.from.minute).padStart(2, '0')}`;
    this.resTimeFilterFormGroup.value.to = `${String(this.resTimeFilterFormGroup.value.to.hour).padStart(
      2,
      '0'
    )}:${String(this.resTimeFilterFormGroup.value.to.minute).padStart(2, '0')}`;
    this.passEntry.emit(this.resTimeFilterFormGroup.value);
  }

  ngOnDestroy(): any {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
